import { ButtonGroup, IconButton } from '@chakra-ui/react';
import { EditorState, RichUtils } from 'draft-js';
import * as React from 'react';

import {
  BoldIcon,
  ItalicIcon,
  ListIcon,
  UnderlineIcon,
} from '@/imports/ui/chakra/feather';
import { AddLinkButton } from '@/modules/draft-js-link-plugin';

import { NumberedListIcon } from './components/NumberedListIcon';

type ToolbarProps = {
  editorState: EditorState;
  setEditorState: (editorState: EditorState) => void;
  isDisabled?: boolean;
};

export const Toolbar: React.FC<ToolbarProps> = ({
  editorState,
  setEditorState,
  isDisabled,
}) => {
  const selection = editorState.getSelection();
  const contentState = editorState.getCurrentContent();
  const blockType = contentState
    .getBlockForKey(selection.getStartKey())
    .getType();

  const currentStyle = editorState.getCurrentInlineStyle();

  return (
    <ButtonGroup
      spacing="2"
      variant="ghost"
      colorScheme="gray"
      size="sm"
      border="1px"
      borderColor="gray.100"
      borderRadius="md"
      backgroundColor="white"
      isDisabled={isDisabled}
      mt="4"
    >
      <IconButton
        isActive={currentStyle.has('BOLD')}
        icon={<BoldIcon />}
        aria-label="bold"
        //https://github.com/facebook/draft-js/issues/696#issuecomment-302903086
        onMouseDown={(event) => {
          event.preventDefault();
          setEditorState(RichUtils.toggleInlineStyle(editorState, 'BOLD'));
        }}
      />
      <IconButton
        isActive={currentStyle.has('ITALIC')}
        icon={<ItalicIcon />}
        aria-label="italic"
        onMouseDown={(event) => {
          event.preventDefault();
          setEditorState(RichUtils.toggleInlineStyle(editorState, 'ITALIC'));
        }}
      />
      <IconButton
        isActive={currentStyle.has('UNDERLINE')}
        icon={<UnderlineIcon />}
        aria-label="underline"
        onMouseDown={(event) => {
          event.preventDefault();
          setEditorState(RichUtils.toggleInlineStyle(editorState, 'UNDERLINE'));
        }}
      />
      <IconButton
        isActive={blockType === 'ordered-list-item'}
        icon={<NumberedListIcon />}
        aria-label="ordered list"
        onMouseDown={(event) => {
          event.preventDefault();
          setEditorState(
            RichUtils.toggleBlockType(editorState, 'ordered-list-item')
          );
        }}
      />
      <IconButton
        isActive={blockType === 'unordered-list-item'}
        icon={<ListIcon />}
        aria-label="unordered list"
        onMouseDown={(event) => {
          event.preventDefault();
          setEditorState(
            RichUtils.toggleBlockType(editorState, 'unordered-list-item')
          );
        }}
      />
      <AddLinkButton
        editorState={editorState}
        setEditorState={setEditorState}
        aria-label="link"
      />
    </ButtonGroup>
  );
};
